import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { NgpLabelValue } from '../../../form/NgpLabelValue';
import {
    COMPUTER_DESCRIPTION_FIELD,
    COMPUTER_NAME_FIELD,
    CREDENTIAL_FIELD,
    CREDENTIAL_TIME_FIELD,
    INSTALLED_MEMORY_FIELD,
    LABEL_COMPUTER_DESCRIPTION,
    LABEL_COMPUTER_NAME,
    LABEL_CREDENTIAL_TIME,
    LABEL_INSTALLED_MEMORY,
    LABEL_IP_ADDRESS_NAME,
    LABEL_NICS,
    LABEL_OPERATING_SYSTEM,
    LABEL_PROCESSOR,
    LABEL_UP_TIME,
    NICS_FIELD,
    OPERATING_SYSTEM_FIELD,
    PROCESSOR_FIELD,
} from './DeviceConstants';
import { LABEL_CREDENTIAL, LABEL_IP_ADDRESSES } from '../InfrastructureConstants';
import DeviceSites from './DeviceSites';
import { EMPTY_VALUE, safeValue } from './DeviceDetailProperties';
import { PropertiesGridFullWidth } from '../../../form/PropertiesGrid';
import PropertiesIpAddressList from '../../../properties/PropertiesIpAddressList';
import { renderStringList } from '../../../properties/Properties';

const ServerProperties = ({ properties, upTime, credentialTime }) => {
    return (
        <>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_COMPUTER_NAME} dataValue={safeValue(properties[COMPUTER_NAME_FIELD])} />
            </PropertiesGridFullWidth>
            <PropertiesGridFullWidth>
                <NgpLabelValue dataLabel={LABEL_IP_ADDRESS_NAME} dataValue={safeValue(properties.ipAddress)} />
            </PropertiesGridFullWidth>
            {properties[CREDENTIAL_FIELD] && (
                <NgpLabelValue dataLabel={LABEL_CREDENTIAL} dataValue={properties[CREDENTIAL_FIELD]} />
            )}
            {properties[CREDENTIAL_TIME_FIELD] && (
                <NgpLabelValue dataLabel={LABEL_CREDENTIAL_TIME} dataValue={credentialTime} />
            )}
            <NgpLabelValue
                dataLabel={LABEL_OPERATING_SYSTEM}
                dataValue={safeValue(properties[OPERATING_SYSTEM_FIELD])}
            />
            <NgpLabelValue dataLabel={LABEL_UP_TIME} dataValue={upTime} />
            <NgpLabelValue dataLabel={LABEL_PROCESSOR} dataValue={safeValue(properties[PROCESSOR_FIELD])} />
            <NgpLabelValue
                dataLabel={LABEL_INSTALLED_MEMORY}
                dataValue={safeValue(properties[INSTALLED_MEMORY_FIELD])}
            />
            <NgpLabelValue dataLabel={LABEL_NICS} dataValue={renderStringList(properties[NICS_FIELD], NICS_FIELD)} />
            <PropertiesGridFullWidth>
                <NgpLabelValue
                    dataLabel={LABEL_COMPUTER_DESCRIPTION}
                    dataValue={safeValue(properties[COMPUTER_DESCRIPTION_FIELD])}
                    wrap
                />
            </PropertiesGridFullWidth>
            <DeviceSites deviceIpAddress={properties.deviceIpAddress} sites={properties.sites} />
            <NgpLabelValue
                dataLabel={LABEL_IP_ADDRESSES}
                dataValue={
                    isEmpty(properties.ipAddresses) ? (
                        EMPTY_VALUE
                    ) : (
                        <PropertiesIpAddressList value={properties.ipAddresses} />
                    )
                }
            />
        </>
    );
};

ServerProperties.propTypes = {
    properties: PropTypes.object.isRequired,
    upTime: PropTypes.string,
    credentialTime: PropTypes.string,
};

ServerProperties.defaultProps = {
    upTime: null,
    credentialTime: null,
};

export default ServerProperties;
